import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./settingsOptions.css";
import "./shared.css";
import { GetUserSettings, UpdateUserSettings, UpdateLanguage } from "../database/userInfo";
import { loadDatabases } from "../database/databaseLoader";
import { useSettings } from "../Navbar/settingsContext";
import { getTranslations } from "../Shared/translations";
import InfoTooltip from "../Shared/InfoTooltip";

interface UserSettings {
  id: number;
  user_id: number;
  pakket: boolean;
  onlysa: boolean;
  standardUitvoering: string;
  maxadres: number;
}

interface SwcUitvoering {
  id: string;
  displayText: string;
}

/*
const initialState: UserSettings = {
  id: 0,
  user_id: 0,
  pakket: false,
  onlysa: false,
  standardUitvoering: "",
};
*/
interface SettingsOptionsProps {
  //onPakkettenChanged: (checked: boolean) => void;
  //onREL04_08Changed: (checked: boolean) => void;
}

const SettingsOptions: React.FC<SettingsOptionsProps> = (
  {
    //onPakkettenChanged,
    //onREL04_08Changed
  },
) => {
  const { userSettings, setUserSettings } = useSettings();
  //const [userSettings, setUserSettings] = useState<UserSettings | null>(null);
  const [uitvoeringId, setUitvoeringId] = useState<string>("");
  const [maxAddressController, setMaxAddressController] = useState<number>();
  const [language, setLanguage] = useState<string>(
    (sessionStorage.getItem("language") || "NL").replace(/"/g, "").toUpperCase()
  );
 const t = getTranslations();
  const handlepakkettenCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    //onPakkettenChanged(event.target.checked);
    sessionStorage.setItem("pakketten", JSON.stringify(event.target.checked));
    setUserSettings((prev) => ({
      ...prev!,
      [event.target.name]: event.target.checked,
    }));
  };

  const handleRel04_08Check = (event: React.ChangeEvent<HTMLInputElement>) => {
    //onREL04_08Changed(event.target.checked);
    sessionStorage.setItem("rel04_08", JSON.stringify(event.target.checked));
    setUserSettings((prev) => ({
      ...prev!,
      [event.target.name]: event.target.checked,
    }));
  };

  useEffect(() => {
    const getSettings = async () => {
      const data = await GetUserSettings();
      setUserSettings(data.success);
    };

    getSettings();
  }, []);

  const dropdownOptions: SwcUitvoering[] = [
    { id: "100", displayText: "Niko - Cream 100 RGB" },
    { id: "101", displayText: "Niko - White 101 RGB" },
    { id: "122", displayText: "Niko - Anthracite 122 RGB" },
    { id: "161", displayText: "Niko - Black Coated 161 RGB" },
    { id: "NNB", displayText: "Niko - No Buttons NNB RGB" },
    { id: "YNB", displayText: "Bticino - Light Now RGB" },
    {
      id: "YD",
      displayText: "Bticino - Black Light Now RGB",
    },
    {
      id: "YG",
      displayText: "Bticino - Sand Light Now RGB",
    },
    {
      id: "YW",
      displayText: "Bticino - White Light Now RGB",
    },
    { id: "GW", displayText: `Tastu - GW ${t.wit} RGB` },
    { id: "GB", displayText: `Tastu - GB ${t.zwart} RGB` },
  ];
  const handleMaxAdreChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMaxAddressController(Number(event.target.value));
  };

  const handleUitvoeringChanged = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setUitvoeringId(event.target.value);
  };

  const saveSettings = async (settings: UserSettings) => {
    try {
      /*
      const created = await UpdateUserSettings(
        settings.id,
        settings.pakket,
        settings.onlysa,
        settings.standardUitvoering,
        settings.maxadres
      );
      */
      await UpdateUserSettings(
        settings.id,
        settings.pakket,
        settings.onlysa,
        settings.standardUitvoering,
        settings.maxadres,
      );
      //console.log("Settings updated:", created);
    } catch (error) {
      console.error("Fout bij opslaan van settings:", error);
    }
    setUserSettings(settings);
  };

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const updatedInfo: UserSettings = {
      id: Number(formData.get("id")),
      user_id: 0,
      pakket: Boolean(formData.get("pakket")),
      onlysa: Boolean(formData.get("onlysa")),
      standardUitvoering: String(formData.get("swcdropdown")),
      maxadres: Number(formData.get("maxadres")),
    };
    // debugger
    sessionStorage.setItem("maxadres", JSON.stringify(updatedInfo?.maxadres));

    sessionStorage.setItem("pakketten", JSON.stringify(updatedInfo?.pakket));

    sessionStorage.setItem("rel04_08", JSON.stringify(updatedInfo?.onlysa));
    const swcs: SwcUitvoering[] = [
      { id: "100", displayText: "Niko - Cream 100 RGB" },
      { id: "101", displayText: "Niko - White 101 RGB" },
      { id: "122", displayText: "Niko - Anthracite 122 RGB" },
      { id: "161", displayText: "Niko - Black Coated 161 RGB" },
      { id: "NNB", displayText: "Niko - No Buttons NNB RGB" },
      /*
      { id: "N", displayText: "Bticino - N-Light White RGB" },
      { id: "L", displayText: "Bticino -  L-Light Black RGB" },
      { id: "NT", displayText: "Bticino - L-Light-Metal RGB" },
       */
      {
        id: "YNB",
        displayText: "Bticino - Light Now RGB",
      },
      {
        id: "YD",
        displayText: "Bticino - Black Light Now RGB",
      },
      {
        id: "YG",
        displayText: "Bticino - Sand Light Now RGB",
      },
      {
        id: "YW",
        displayText: "Bticino - White Light Now RGB",
      },
      { id: "GW", displayText: `Tastu - GW ${t.wit} RGB` },
      { id: "GB", displayText: `Tastu - GB ${t.zwart} RGB` },
    ];
    const setUitvoeringBySavedSettings = () => {
      swcs.forEach((swcTypes) => {
        if (updatedInfo?.standardUitvoering === swcTypes.id) {
          //console.log(swcTypes.displayText);
          sessionStorage.setItem("uitvoeringText", swcTypes.displayText);
          sessionStorage.setItem("uitvoering", swcTypes.id);
          //setUitvoeringText(swcTypes.displayText);
          //setUitvoering(swcTypes.id);
        }
      });
    };

    saveSettings(updatedInfo);
    setUitvoeringBySavedSettings();

    // Save language
    const normalizedLang = ["NL", "FR", "EN"].includes(language) ? language : "NL";
    const previousLang = sessionStorage.getItem("language") || "NL";
    sessionStorage.setItem("language", normalizedLang);
    UpdateLanguage(normalizedLang);

    if (normalizedLang !== previousLang) {
      loadDatabases().then(() => {
        window.dispatchEvent(new CustomEvent("databasesReloaded"));
      });
    }

    setUserSettings(updatedInfo);
  };

  return (
    <div>
      <Form onSubmit={submitHandler} className="settings-form">
        <Form.Control type="hidden" defaultValue={userSettings?.id} name="id" />

        <div className="settings-check-row">
          <Form.Check.Input
            type="checkbox"
            name="pakket"
            defaultChecked={userSettings?.pakket}
            onChange={handlepakkettenCheck}
          />
          <Form.Check.Label className="settings-check-label">
            {t.gebruikPaketten}
          </Form.Check.Label>
          <InfoTooltip text={<>{t.infoPakettenAan1}<br />{t.infoPakettenAan2}</>} />
        </div>

        <div className="settings-check-row">
          <Form.Check.Input
            type="checkbox"
            name="onlysa"
            defaultChecked={userSettings?.onlysa}
            onChange={handleRel04_08Check}
          />
          <Form.Check.Label className="settings-check-label">
            {t.gebruikEnkelSa}
          </Form.Check.Label>
          <InfoTooltip text={<>{t.infoSaAan1}<br />{t.infoSaAan2}</>} />
        </div>

        <Form.Group>
          <Form.Label className="form-label-primary">{t.upgradeController}</Form.Label>
          <InfoTooltip text={<>{t.infoUpgradeController1}<br />{t.infoUpgradeController2}</>} />
          <Form.Control
            type="text"
            name="maxadres"
            defaultValue={userSettings?.maxadres}
            onChange={handleMaxAdreChanged}
          />
        </Form.Group>

        <Form.Label className="form-label-primary">
          {t.standaardUitvoering}:
          <InfoTooltip text={t.infoStandaardUitvoering} />
        </Form.Label>

        <Form.Select
          aria-label="Selecteer een uitvoering"
          onChange={handleUitvoeringChanged}
          key="UitvoeringDropdown"
          value={uitvoeringId}
          name="swcdropdown"
        >
          {dropdownOptions.map((swcType) => (
            <option value={swcType.id} key={swcType.id}>
              {swcType.displayText}
            </option>
          ))}
        </Form.Select>

        <Form.Label className="form-label-primary">
          {t.taal}:
          <InfoTooltip text={t.infoTaal} />
        </Form.Label>
        <Form.Select
          aria-label="Selecteer een taal"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          name="language"
        >
          <option value="NL">Nederlands</option>
          <option value="FR">Français</option>
          <option value="EN">English</option>
        </Form.Select>

        <div className="settings-actions">
          <Button
            variant="primary"
            type="submit"
            className="btn-primary-app"
          >
            {t.bewaar}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default SettingsOptions;
